var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsApplicationdesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "skills_applicationdesign",
    d: "M4,40V35.5H8.3V11a2.878,2.878,0,0,1,.9-2.1A2.878,2.878,0,0,1,11.3,8h31v3h-31V35.5H23V40Zm23.95,0a1.838,1.838,0,0,1-1.375-.6A2.216,2.216,0,0,1,26,37.8V15.95A1.963,1.963,0,0,1,27.95,14h13.6a2.692,2.692,0,0,1,1.725.575A1.709,1.709,0,0,1,44,15.95V37.8a1.972,1.972,0,0,1-.725,1.6,2.62,2.62,0,0,1-1.725.6ZM29,35.5H41V17H29Z",
    transform: "translate(-4 -8)",
    fill: "#5637fa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsApplicationdesign);
export default __webpack_public_path__ + "static/media/skills_applicationdesign.f0ce8e91a6eaa82d70e33e121743449f.svg";
export { ForwardRef as ReactComponent };